import { useContext, useEffect, useState } from 'react';
import {
    getCountryResultsFromAllPages,
    getPages,
    getTaxonomies
} from '../api/api';
import { AppContext } from '../state/context';
import { extendTaxonomies } from '../utils';

export const useLoadData = () => {
    const { changeState } = useContext(AppContext);
    const [hasError, setHasError] = useState(false);
    const [attempt, setAttempt] = useState(0);

    const retry = () => {
        setHasError(false);
        setAttempt(previous => previous + 1);
    };

    useEffect(() => {
        let cancelled = false;

        const loadData = async () => {
            try {
                const [
                    taxonomies,
                    countryProfiles,
                    pages,
                ] = await Promise.all([
                    getTaxonomies(),
                    getCountryResultsFromAllPages(),
                    getPages(),
                ]);

                extendTaxonomies(taxonomies, countryProfiles);

                if (!cancelled) {
                    changeState(previousState => ({
                        ...previousState,
                        countryProfiles,
                        taxonomies,
                        pages,
                        dataReady: true
                    }));
                }
            }
            catch (error) {
                if (!cancelled) {
                    console.error('ERROR INITIALIZING APP', error);
                    setHasError(true);
                }
            }
        };

        loadData();

        return () => {
            cancelled = true;
        };
    }, [changeState, attempt]);

    return { hasError, retry };
};
